export function errorWobble(element) {
    element.classList.add('errorWobble');
    setTimeout(() => element.classList.remove('errorWobble'), 500);
}
